import * as actions from "../actions";

const initialState = {
  filesQualification: '[]',
  qualificationDescription: '',
  filesTrade: '[]',
  tradeDescription: '',
  finished: null,
  qualificationFilesUploadStatus: null,
  tradeFilesUploadStatus: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.STORE_DOCUMENTS:
      return {
        ...state,
        ...action.payload
      };
    case actions.STORE_UPLOAD_STATUS:
      return {
        ...state,
        ...action.payload
      };
    case actions.GET_APPLICATION_FULFILLED:
      return {
        ...action.payload.documents
      };
    case actions.CLEAR_FORM:
      return {
        ...initialState,
      };
    default:
      return state
  }
}
